import { apiClient } from "./apiClient";

export const baiTapKetQuaApi = {
    SelectByLopBoMon: (lopBoMonId: number)=> apiClient.get(`bai-tap-ket-qua/lop-bo-mon/${lopBoMonId}`)
}